// extracted by mini-css-extract-plugin
export default {"container":"login_container__wWIgn","wrapper":"login_wrapper__wZIBU","dot":"login_dot__2aaR6","animate":"login_animate__Mw1TH"};